import React from 'react';
import {Route, Switch, Redirect} from 'react-router-dom';
import axios from './services/axios';
import * as devicesService from './services/devices';
import AuthenticationContext from './contexts/AuthenticationContext';
import Camera from './pages/Camera';
import Home from './pages/Home';
import Manage from './pages/Manage';

// TODO PWA: Site cannot be installed: a 144px square PNG icon is required, but no supplied icon meets this requirement; a 192x192 png icon (the icon declarations must include a mime type of image/png)

class App extends React.Component {

    constructor(props) {

        super(props);

        this.state = {

            auth: {

                device: JSON.parse(window.localStorage.getItem('device')),
                setDevice: this.setDevice.bind(this),
                setUser: this.setUser.bind(this),
                user: JSON.parse(window.localStorage.getItem('user')),
            },
        };

        this.updateAxiosAuthorization();
    }

    componentDidMount() {

        if (!this.state.auth.device)
            devicesService.save().then(result => result.item).then(device => this.setDevice(device));
    }

    componentDidUpdate(prevProps, prevState) {

        if (this.state.auth.device !== prevState.auth.device)
            window.localStorage.setItem('device', JSON.stringify(this.state.auth.device));

        if (this.state.auth.user !== prevState.auth.user)
            window.localStorage.setItem('user', JSON.stringify(this.state.auth.user));
    }

    render() {

        return (

            <AuthenticationContext.Provider value={this.state.auth}>
                <Switch>
                    <Route path="/" exact component={Home}/>
                    <Route path="/camera" component={Camera}/>
                    {this.state.auth.user && (

                        <Route path="/manage" component={Manage}/>
                    )}
                    {!this.state.auth.user && (

                        <Redirect from="/manage" to="/"/>
                    )}
                </Switch>
            </AuthenticationContext.Provider>
        );
    }

    setDevice(newValue) {

        this.setState((prevState, props) => ({

            auth: Object.assign({}, prevState.auth, {device: newValue}),

        }), this.updateAxiosAuthorization);
    }

    setUser(newValue) {

        this.setState((prevState, props) => ({

            auth: Object.assign({}, prevState.auth, {user: newValue}),

        }), this.updateAxiosAuthorization);
    }

    updateAxiosAuthorization() {

        axios.defaults.auth = this.state.auth.user ? {

            username: this.state.auth.user.email,
            password: this.state.auth.user.hash,

        } : null;

        axios.defaults.deviceAuth = this.state.auth.device ? {

            username: this.state.auth.device.deviceid,
            password: this.state.auth.device.devicehash,

        } : null;
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App.js